export const roundScore = (score: number): number => {
	const numberPoint = score % 1;
	return numberPoint < 0.5 || score > 99 ? Math.floor(score) : Math.ceil(score);
};
